/* Product V5 — Vanilla JS */
(function(){
  'use strict';

  /* === Reveal on scroll === */
  var obs = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){ e.target.classList.add('visible'); obs.unobserve(e.target); }
    });
  }, {threshold: 0.05, rootMargin: '0px 0px 80px 0px'});
  document.querySelectorAll('.reveal').forEach(function(el){ obs.observe(el); });

  /* === Gallery === */
  var gallery = document.querySelector('.pv5-gallery');
  var galleryMain = document.getElementById('pv5-gallery-main');
  var slides = document.querySelectorAll('.pv5-gallery__slide');
  var thumbs = document.querySelectorAll('.pv5-gallery__thumb');
  var dots = document.querySelectorAll('.pv5-gallery__dot');
  var prevBtn = document.querySelector('.pv5-gallery__arrow--prev');
  var nextBtn = document.querySelector('.pv5-gallery__arrow--next');
  var currentSlide = 0;
  var totalSlides = slides.length;

  function showSlide(i){
    if(i < 0) i = totalSlides - 1;
    if(i >= totalSlides) i = 0;
    currentSlide = i;
    slides.forEach(function(s,idx){ s.classList.toggle('active', idx===i); });
    thumbs.forEach(function(t,idx){ t.classList.toggle('active', idx===i); });
    dots.forEach(function(d,idx){ d.classList.toggle('active', idx===i); });
    if(galleryMain && window.innerWidth < 600){
      galleryMain.scrollTo({left: i * galleryMain.offsetWidth, behavior: 'smooth'});
    }
  }

  if(prevBtn) prevBtn.addEventListener('click', function(){ showSlide(currentSlide - 1); });
  if(nextBtn) nextBtn.addEventListener('click', function(){ showSlide(currentSlide + 1); });
  thumbs.forEach(function(t){ t.addEventListener('click', function(){ showSlide(+this.dataset.index); }); });
  dots.forEach(function(d){ d.addEventListener('click', function(){ showSlide(+this.dataset.index); }); });

  /* Mobile swipe sync — real-time indicator update */
  function syncIndicator(){
    var w = galleryMain.offsetWidth;
    if(w <= 0) return;
    var idx = Math.round(galleryMain.scrollLeft / w);
    if(idx < 0) idx = 0;
    if(idx >= totalSlides) idx = totalSlides - 1;
    if(idx !== currentSlide){
      currentSlide = idx;
      slides.forEach(function(s,i){ s.classList.toggle('active', i===idx); });
      thumbs.forEach(function(t,i){ t.classList.toggle('active', i===idx); });
      dots.forEach(function(d,i){ d.classList.toggle('active', i===idx); });
    }
  }

  if(galleryMain){
    var pollId = 0;
    function startPoll(){ if(!pollId) pollId = setInterval(syncIndicator, 16); }
    function stopPoll(ms){
      setTimeout(function(){ clearInterval(pollId); pollId = 0; syncIndicator(); }, ms || 0);
    }
    galleryMain.addEventListener('touchstart', startPoll, {passive: true});
    galleryMain.addEventListener('touchend', function(){ stopPoll(400); }, {passive: true});
    galleryMain.addEventListener('touchcancel', function(){ stopPoll(400); }, {passive: true});
    galleryMain.addEventListener('scroll', function(){
      if(!pollId) requestAnimationFrame(syncIndicator);
    }, {passive: true});
  }

  /* === G) Lightbox on Click — replaces hover-zoom (User-Feedback SHO-116) === */
  function openLightbox(srcEl){
    if(!srcEl) return;
    var src = srcEl.currentSrc || srcEl.src;
    if(!src) return;
    var lb = document.createElement('div');
    lb.className = 'pv5-lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.innerHTML = '<button class="pv5-lightbox__close" aria-label="Close">&times;</button><img class="pv5-lightbox__img" alt="">';
    var img = lb.querySelector('.pv5-lightbox__img');
    img.src = src;
    img.alt = srcEl.alt || '';
    document.body.appendChild(lb);
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function(){ lb.classList.add('open'); });
    function close(){
      lb.classList.remove('open');
      document.body.style.overflow = '';
      setTimeout(function(){ lb.remove(); }, 200);
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e){ if(e.key === 'Escape') close(); }
    lb.addEventListener('click', function(e){
      if(e.target === lb || e.target.classList.contains('pv5-lightbox__close')) close();
    });
    document.addEventListener('keydown', onKey);
  }
  // Gallery click → lightbox (active slide image)
  if(galleryMain){
    galleryMain.addEventListener('click', function(e){
      // Ignore clicks on arrows
      if(e.target.closest('.pv5-gallery__arrow')) return;
      var img = galleryMain.querySelector('.pv5-gallery__slide.active img') ||
                galleryMain.querySelector('.pv5-gallery__slide img');
      openLightbox(img);
    });
  }
  // Storytelling images click → lightbox
  document.querySelectorAll('.pv5-story-beat__image').forEach(function(img){
    img.style.cursor = 'zoom-in';
    img.addEventListener('click', function(){ openLightbox(img); });
  });

  /* === Quantity === */
  document.querySelectorAll('.pv5-qty__btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      var input = this.parentElement.querySelector('.pv5-qty__input');
      var v = parseInt(input.value) || 1;
      input.value = this.dataset.action === 'plus' ? v+1 : Math.max(1, v-1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* === Product JSON === */
  var pJson = document.getElementById('pv5-product-json');
  var product = null;
  if(pJson){
    try { product = JSON.parse(pJson.textContent); } catch(e){}
  }

  /* === Helper: format price for ATC button === */
  function getAtcText(variant){
    if(!variant || !variant.available) return 'Sold Out';
    var price = (variant.price / 100).toFixed(2);
    // Use Shopify money format if available
    if(window.Shopify && window.Shopify.currency && window.Shopify.currency.active){
      var sym = '$';
      if(window.Shopify.currency.active === 'EUR') sym = '€';
      else if(window.Shopify.currency.active === 'GBP') sym = '£';
      return 'Add to Cart — ' + sym + price;
    }
    return 'Add to Cart — $' + price;
  }

  var form = document.getElementById('pv5-form');
  var stock = window.OrblyStock.initProduct(5);
  var adding = false;
  function addToCart(button) {
    stock.update();
    if (adding || button.disabled) return;
    adding = true;
    stock.error();
    button.classList.add('loading');
    button.setAttribute('aria-disabled', 'true');
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({items: [{id: +form.querySelector('[name="id"]').value, quantity: Number(form.querySelector('[name="quantity"]').value)}]})
    }).then(function(response) {
      return response.json().then(function(data) {
        if (!response.ok || data.status) throw new Error(data.description || window.cartStrings.error);
        button.classList.add('success');
        var label = button.querySelector('.pv5-atc-btn__text, .pv4-atc-btn__text') || button;
        var originalText = label.textContent;
        label.textContent = window.stockStrings.added;
        setTimeout(function() {
          button.classList.remove('success');
          if (label.textContent === window.stockStrings.added) label.textContent = originalText;
          stock.update();
        }, 1200);
        publish(PUB_SUB_EVENTS.cartUpdate, {source: 'pv5-form'});
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      });
    }).catch(function(error) {
      stock.error(error.message);
      window.OrblyStock.schedule();
    }).finally(function() {
      adding = false;
      button.classList.remove('loading');
      stock.update();
    });
  }
  if (form) form.addEventListener('submit', function(event) {
    event.preventDefault();
    stock.update();
    addToCart(form.querySelector('[type="submit"]'));
  });

  /* === Get current variant from selected options === */
  function getCurrentVariant(){
    if(!product) return null;
    var opts = [];
    document.querySelectorAll('.pv5-variants').forEach(function(vg){
      var a = vg.querySelector('.pv5-variant-btn.active');
      if(a) opts.push(a.dataset.value);
    });
    if(opts.length === 0 && product.variants.length > 0) return product.variants[0];
    return product.variants.find(function(v){
      return v.options.every(function(o,i){ return !opts[i] || o === opts[i]; });
    }) || product.variants[0];
  }

  /* === Sticky ATC === */
  var mainCTA = document.getElementById('pv5-main-atc');
  var sticky = document.getElementById('pv5-sticky');
  var storytellingEl = document.querySelector('.pv5-storytelling');
  var stickyTriggerEl = storytellingEl || document.querySelector('.pv5-how');

  function updateStickyVisibility(){
    // SHO-199: pv5-sticky visible only in buy-zones (storytelling OR compare)
    if(!sticky) return;
    var story = document.querySelector('.pv5-storytelling');
    var compare = document.querySelector('.pv5-compare');
    function pv5InZone(el){
      if(!el) return false;
      var r = el.getBoundingClientRect();
      return r.bottom > 80 && r.top < (window.innerHeight - 80);
    }
    var inBuyZone = pv5InZone(story) || pv5InZone(compare);
    sticky.classList.toggle('visible', inBuyZone);
  }

  window.addEventListener('scroll', updateStickyVisibility, {passive: true});
  updateStickyVisibility();

  if(sticky){
    var sBtn = sticky.querySelector('.pv5-sticky__btn');
    if(sBtn){
      sBtn.addEventListener('click', function(){
        addToCart(this);
      });
    }
  }

  /* === FAQ Accordion === */
  document.querySelectorAll('.pv5-faq__q').forEach(function(q){
    q.addEventListener('click', function(){
      var item = this.closest('.pv5-faq__item');
      var open = item.classList.contains('open');
      document.querySelectorAll('.pv5-faq__item').forEach(function(i){ i.classList.remove('open'); i.querySelector('.pv5-faq__q').setAttribute('aria-expanded','false'); });
      if(!open){ item.classList.add('open'); this.setAttribute('aria-expanded','true'); }
    });
  });

  /* === Variant Selector — SHO-232: availability + variant images === */
  function getSelectedOptionValues(){
    var opts = [];
    document.querySelectorAll('.pv5-variants').forEach(function(vg){
      var a = vg.querySelector('.pv5-variant-btn.active');
      opts.push(a ? a.dataset.value : null);
    });
    return opts;
  }

  function refreshVariantAvailability(){
    if(!product || !product.variants) return;
    var groups = document.querySelectorAll('.pv5-variants');
    var selected = getSelectedOptionValues();
    groups.forEach(function(group, gi){
      group.querySelectorAll('.pv5-variant-btn').forEach(function(btn){
        var probe = selected.slice();
        probe[gi] = btn.dataset.value;
        var anyAvail = product.variants.some(function(v){
          if(!v.available) return false;
          return v.options.every(function(o, i){ return !probe[i] || o === probe[i]; });
        });
        btn.dataset.available = anyAvail ? 'true' : 'false';
        btn.setAttribute('aria-disabled', anyAvail ? 'false' : 'true');
      });
      var act = group.querySelector('.pv5-variant-btn.active');
      var label = group.querySelector('[data-option-current]');
      if(label && act) label.textContent = act.dataset.value;
    });
  }

  function showSlideByImageId(id){
    if(!id) return false;
    var idx = -1;
    document.querySelectorAll('.pv5-gallery__slide').forEach(function(s, i){
      if(s.dataset.imageId == id) idx = i;
    });
    if(idx >= 0){ showSlide(idx); return true; }
    return false;
  }

  if(product){
    document.querySelectorAll('.pv5-variant-btn').forEach(function(pill){
      pill.addEventListener('click', function(){
        this.parentElement.querySelectorAll('.pv5-variant-btn').forEach(function(p){ p.classList.remove('active'); });
        this.classList.add('active');
        var match = getCurrentVariant();
        refreshVariantAvailability();
        if(match){
          document.querySelector('input[name="id"]').value = match.id;
          // Switch gallery to variant featured image (if any)
          if(match.featured_image && match.featured_image.id){
            showSlideByImageId(match.featured_image.id);
          }
          // Update main ATC button text with price
          var mainBtn = document.getElementById('pv5-main-atc');
          if(mainBtn){
            var textEl = mainBtn.querySelector('.pv5-atc-btn__text');
            if(textEl) textEl.textContent = getAtcText(match);
            mainBtn.disabled = !match.available;
            mainBtn.dataset.atcPrice = match.available ? (match.price / 100).toFixed(2) : '';
          }
          // Update sticky ATC
          var sb = document.querySelector('.pv5-sticky__btn');
          if(sb){
            sb.dataset.variantId = match.id;
            sb.textContent = getAtcText(match);
            sb.disabled = !match.available;
          }
          stock.update(match);
          // Update price display (hero) + sticky price + compare/save — SHO-236
          function pv5Money(cents){
            var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
            var sym = cur === 'EUR' ? '€' : '$';
            return sym + (cents / 100).toFixed(2);
          }
          var priceDisplay = document.getElementById('pv5-price-display');
          if(priceDisplay){
            var currentEl = priceDisplay.querySelector('.pv5-price__current');
            var compareEl = priceDisplay.querySelector('.pv5-price__compare');
            var saveEl    = priceDisplay.querySelector('.pv5-price__save');
            if(currentEl) currentEl.textContent = pv5Money(match.price);
            var hasCompare = match.compare_at_price && match.compare_at_price > match.price;
            if(compareEl){
              if(hasCompare){
                compareEl.textContent = pv5Money(match.compare_at_price);
                compareEl.hidden = false;
              } else {
                compareEl.textContent = '';
                compareEl.hidden = true;
              }
            }
            if(saveEl){
              if(hasCompare){
                saveEl.textContent = 'Save ' + pv5Money(match.compare_at_price - match.price);
                saveEl.hidden = false;
              } else {
                saveEl.textContent = '';
                saveEl.hidden = true;
              }
            }
          }
          // Update sticky price
          var stickyPrice = document.querySelector('.pv5-sticky__price');
          if(stickyPrice){
            stickyPrice.textContent = pv5Money(match.price);
          }
        }
      });
    });
    refreshVariantAvailability();
  }

  /* === Thumbnail scroll affordance — SHO-232 === */
  var thumbsWrap = document.querySelector('.pv5-gallery__thumbs-wrap');
  var thumbsScroll = thumbsWrap ? thumbsWrap.querySelector('.pv5-gallery__thumbs') : null;
  function updateThumbScrollState(){
    if(!thumbsWrap || !thumbsScroll) return;
    var canScroll = thumbsScroll.scrollHeight > thumbsScroll.clientHeight + 1;
    var atTop = thumbsScroll.scrollTop <= 1;
    var atBottom = thumbsScroll.scrollTop + thumbsScroll.clientHeight >= thumbsScroll.scrollHeight - 1;
    thumbsWrap.dataset.canScrollUp = canScroll && !atTop ? '1' : '0';
    thumbsWrap.dataset.canScrollDown = canScroll && !atBottom ? '1' : '0';
  }
  if(thumbsScroll){
    thumbsScroll.addEventListener('scroll', updateThumbScrollState, {passive: true});
    window.addEventListener('resize', updateThumbScrollState, {passive: true});
    updateThumbScrollState();
    setTimeout(updateThumbScrollState, 250);
  }
  // Keep active thumb in view when slide changes (desktop vertical scroll)
  var origShowSlide = showSlide;
  showSlide = function(i){
    origShowSlide(i);
    if(thumbsScroll && window.innerWidth >= 1024){
      var t = thumbsScroll.querySelector('.pv5-gallery__thumb.active');
      if(t && t.scrollIntoView){
        var r = t.getBoundingClientRect();
        var pr = thumbsScroll.getBoundingClientRect();
        if(r.top < pr.top || r.bottom > pr.bottom){
          t.scrollIntoView({block: 'nearest', behavior: 'smooth'});
        }
      }
      updateThumbScrollState();
    }
  };

  /* === I) Delivery Estimate === */
  function updateDeliveryEstimate(){
    var countdownEl = document.getElementById('pv5-delivery-countdown');
    var dateEl = document.getElementById('pv5-delivery-date');
    if(!countdownEl || !dateEl) return;

    var now = new Date();
    var cutoffHour = 14; // 2 PM
    var today = new Date(now);
    today.setHours(cutoffHour, 0, 0, 0);

    var beforeCutoff = now < today;
    var daysToAdd = beforeCutoff ? 7 : 8;

    // Delivery date
    var deliveryDate = new Date(now);
    deliveryDate.setDate(deliveryDate.getDate() + daysToAdd);
    var days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    var months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    dateEl.textContent = days[deliveryDate.getDay()] + ', ' + months[deliveryDate.getMonth()] + ' ' + deliveryDate.getDate();

    // Countdown to cutoff
    if(beforeCutoff){
      var diff = today - now;
      var hrs = Math.floor(diff / 3600000);
      var mins = Math.floor((diff % 3600000) / 60000);
      countdownEl.textContent = hrs + 'h ' + mins + 'm';
    } else {
      // After cutoff: countdown to tomorrow's cutoff
      var tomorrow = new Date(now);
      tomorrow.setDate(tomorrow.getDate() + 1);
      tomorrow.setHours(cutoffHour, 0, 0, 0);
      var diff2 = tomorrow - now;
      var hrs2 = Math.floor(diff2 / 3600000);
      var mins2 = Math.floor((diff2 % 3600000) / 60000);
      countdownEl.textContent = hrs2 + 'h ' + mins2 + 'm';
    }
  }

  updateDeliveryEstimate();
  setInterval(updateDeliveryEstimate, 60000); // Update every minute

})();

/* === Marquee auto-fill === */
(function(){
  document.querySelectorAll('.pv5-marquee-track').forEach(function(track) {
    var row = track.parentElement;
    if (!row || !track.children.length) return;
    var originals = [];
    Array.from(track.children).forEach(function(card) {
      if (card.getAttribute('aria-hidden') !== 'true') {
        originals.push(card.outerHTML);
      }
    });
    if (!originals.length) return;
    track.innerHTML = originals.join('');
    var minWidth = window.innerWidth * 2 + 500;
    var safetyCounter = 0;
    while (track.scrollWidth < minWidth && safetyCounter < 20) {
      originals.forEach(function(html) {
        var wrapper = document.createElement('div');
        wrapper.innerHTML = html;
        var clone = wrapper.firstElementChild;
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
      safetyCounter++;
    }
    var currentCards = track.innerHTML;
    track.innerHTML = currentCards + currentCards;
  });
})();

// Marquee: pause on touch (mobile)
document.querySelectorAll('.pv5-marquee-row').forEach(function(row) {
  row.addEventListener('touchstart', function() {
    row.querySelector('.pv5-marquee-track').style.animationPlayState = 'paused';
  }, { passive: true });
  row.addEventListener('touchend', function() {
    row.querySelector('.pv5-marquee-track').style.animationPlayState = 'running';
  }, { passive: true });
});


/* === Benefit spotlight (2026-09-09) ===
   The server renders every benefit stacked in one grid cell; only the first is
   .is-active. The `hidden` attribute on the others is a no-JS fallback (without
   JS the page shows benefit 01 and nothing else), so it is stripped on init and
   CSS owns visibility from then on. Index / arrows / swipe all drive go(). */
(function(){
  'use strict';
  var roots = document.querySelectorAll('[data-spot]');
  if (!roots.length) return;

  Array.prototype.forEach.call(roots, function(root){
    var items = root.querySelectorAll('[data-spot-item]');
    var tabs = root.querySelectorAll('[data-spot-tab]');
    var total = items.length;
    if (!total) return;

    var stage = root.querySelector('[data-spot-stage]');
    var list = root.querySelector('[role="tablist"]');
    var prevBtn = root.querySelector('[data-spot-prev]');
    var nextBtn = root.querySelector('[data-spot-next]');
    var counter = root.querySelector('[data-spot-current]');
    var index = 0;
    var hoverTimer = null;

    function pad(n){ return n < 10 ? '0' + n : String(n); }

    /* CSS takes over now — keep every item in the grid so the panel stays as
       tall as the tallest benefit. */
    Array.prototype.forEach.call(items, function(item){ item.removeAttribute('hidden'); });

    function go(i, focusTab){
      i = i % total;
      if (i < 0) i += total;
      index = i;
      Array.prototype.forEach.call(items, function(item, n){
        item.classList.toggle('is-active', n === i);
      });
      Array.prototype.forEach.call(tabs, function(tab, n){
        var on = n === i;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('tabindex', on ? '0' : '-1');
      });
      if (counter) counter.textContent = pad(i + 1);
      root.setAttribute('data-spot-active', String(i));
      if (focusTab && tabs[i]) tabs[i].focus();
    }

    Array.prototype.forEach.call(tabs, function(tab, n){
      tab.addEventListener('click', function(){ go(n); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function(){ go(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function(){ go(index + 1); });

    /* Roving tabindex: arrows move the selection and the focus together. */
    if (list) {
      list.addEventListener('keydown', function(e){
        var k = e.key;
        var target;
        if (k === 'ArrowRight' || k === 'ArrowDown') target = index + 1;
        else if (k === 'ArrowLeft' || k === 'ArrowUp') target = index - 1;
        else if (k === 'Home') target = 0;
        else if (k === 'End') target = total - 1;
        else return;
        e.preventDefault();
        go(target, true);
      });
    }

    /* Desktop pointers only: a short dwell over a row previews it. Leaving
       cancels the pending switch but never reverts an applied one. */
    var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)');
    if (fine && fine.matches) {
      Array.prototype.forEach.call(tabs, function(tab, n){
        tab.addEventListener('mouseenter', function(){
          if (hoverTimer) clearTimeout(hoverTimer);
          hoverTimer = setTimeout(function(){ hoverTimer = null; go(n); }, 120);
        });
        tab.addEventListener('mouseleave', function(){
          if (hoverTimer) { clearTimeout(hoverTimer); hoverTimer = null; }
        });
      });
    }

    /* Swipe — passive listeners, so vertical scrolling is never blocked. */
    if (stage && total > 1) {
      var startX = 0, startY = 0, tracking = false;
      var onStart = function(x, y){ startX = x; startY = y; tracking = true; };
      var onEnd = function(x, y){
        if (!tracking) return;
        tracking = false;
        var dx = x - startX;
        var dy = y - startY;
        if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return;
        go(dx < 0 ? index + 1 : index - 1);
      };
      if (window.PointerEvent) {
        stage.addEventListener('pointerdown', function(e){
          if (e.pointerType === 'mouse') { tracking = false; return; }
          onStart(e.clientX, e.clientY);
        }, { passive: true });
        stage.addEventListener('pointerup', function(e){ onEnd(e.clientX, e.clientY); }, { passive: true });
        stage.addEventListener('pointercancel', function(){ tracking = false; }, { passive: true });
      } else {
        stage.addEventListener('touchstart', function(e){
          var t = e.changedTouches[0];
          onStart(t.clientX, t.clientY);
        }, { passive: true });
        stage.addEventListener('touchend', function(e){
          var t = e.changedTouches[0];
          onEnd(t.clientX, t.clientY);
        }, { passive: true });
      }
    }

    go(0);
  });
})();
